/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Cameras.Scene2D
 */

module.exports = {

    Camera: require('./Camera'),
    CameraManager: require('./CameraManager')

};



//////////////////
// WEBPACK FOOTER
// ./cameras/2d/index.js
// module id = 470
// module chunks = 0